
export enum action {
  create = 'create',
  view = 'view',
  update = 'update',
  disable = 'disable',
  delete = 'delete',
  disconnect = 'disconnect',
  refresh = 'refresh',
  initialLoading = 'initialLoading',
  nothing = 'nothing',
  portalUser = 'portalUser',
  apiClient = 'apiClient'
}
